import React from 'react'
import { BsArrowRight } from "react-icons/bs";
import { FaInstagram, FaFacebook, FaYoutube } from "react-icons/fa";
import { HiOutlineMailOpen } from "react-icons/hi";
import { GoLocation } from "react-icons/go";
import { IoChatbubbleOutline } from "react-icons/io5";
import Logo from "../images/IMG.PNG";
import { CiPhone } from "react-icons/ci";
import { Link } from 'react-router-dom';

function Footer() {
  // Function to scroll to the top of the page
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  return (
    <div className='w-full bg-gradient-to-br from-[#f8f6f0] via-[#ede8dc]  to-[#e6ddd0] mt-16 relative overflow-hidden'>
      {/* Decorative background elements */}
      <div className='absolute top-0 left-0 w-full h-full opacity-5'>
        <div className='absolute top-10 left-10 w-32 h-32 bg-gradient-to-br from-purple-400 to-pink-400 rounded-full blur-3xl'></div>
        <div className='absolute bottom-20 right-20 w-40 h-40 bg-gradient-to-br from-blue-400 to-teal-400 rounded-full blur-3xl'></div>
        <div className='absolute top-1/2 left-1/3 w-24 h-24 bg-gradient-to-br from-yellow-400 to-orange-400 rounded-full blur-2xl'></div>
      </div>

      <div className='w-full px-6 md:px-12 lg:px-16 flex flex-col py-12 relative z-10'>
        <div className='border-t border-b border-gray-300/30 w-full py-16 md:py-20 flex lg:flex-row flex-col items-start justify-between gap-12'>
          
          {/* Brand Section */}
          <div className='flex flex-col lg:w-1/3 w-full gap-6'>
            <div className='flex gap-4 items-center'>
              <div className='relative group'>
                <img src={Logo} alt="Yogabyjasmin Logo" className='w-20 h-20 object-cover rounded-full shadow-lg transition-transform duration-300 group-hover:scale-105' />
                <div className='absolute inset-0 rounded-full bg-gradient-to-r from-purple-400/20 to-pink-400/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300'></div>
              </div>
              <h2 className='text-3xl md:text-4xl font-light text-gray-800 tracking-wide'>Yogabyjasmin</h2>
            </div>
            
            <blockquote className='text-lg font-light text-gray-700 leading-relaxed border-l-4 border-gradient-to-b from-purple-400 to-pink-400 pl-4 italic'>
              "The soul loves to meditate, for in contact with the Spirit lies its greatest joy."
              <footer className='text-sm font-semibold mt-2 text-gray-600'>— Paramahansa Yogananda</footer>
            </blockquote>
            
            <div className='flex items-center gap-4 mt-4'>
              <a href="#" className='group relative p-3 bg-white rounded-full shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1'>
                <FaFacebook size={24} className='text-[#0765ff] group-hover:scale-110 transition-transform duration-300'/>
                <div className='absolute inset-0 bg-gradient-to-r from-blue-400/20 to-blue-600/20 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300'></div>
              </a>
              <a href="https://www.instagram.com/yogabyjasmin/?hl=en" className='group relative p-3 bg-white rounded-full shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1'>
                <FaInstagram size={24} className='text-[#ff3289] group-hover:scale-110 transition-transform duration-300'/>
                <div className='absolute inset-0 bg-gradient-to-r from-pink-400/20 to-purple-600/20 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300'></div>
              </a>
              <a href="https://youtube.com/@yogabyjasmin?si=JPzfoklo6KA6dygY" className='group relative p-3 bg-white rounded-full shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1'>
                <FaYoutube size={24} className='text-[#ff0000] group-hover:scale-110 transition-transform duration-300'/>
                <div className='absolute inset-0 bg-gradient-to-r from-red-400/20 to-red-600/20 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300'></div>
              </a>
            </div>
          </div>

          {/* Navigation Section */}
          <div className='flex flex-col  lg:w-1/3 w-full items-center justify-start gap-6'>
            <h3 className='text-3xl font-light text-gray-800 text-center'>Pages</h3>
            <nav className='flex md:flex-col gap-3 text-center'>
              <Link to="/" className='text-lg font-light text-gray-700 hover:text-[#ffffff] transition-colors duration-300 hover:scale-105 transform' onClick={scrollToTop}>
                Home
              </Link>
              <Link to="/retreats" className='text-lg font-light text-gray-700 hover:text-[#ffffff] transition-colors duration-300 hover:scale-105 transform' onClick={scrollToTop}>
                Retreats
              </Link>
              <Link to="/gallery" className='text-lg font-light text-gray-700 hover:text-[#ffffff] transition-colors duration-300 hover:scale-105 transform' onClick={scrollToTop}>
                Gallery
              </Link>
              <Link to="/about" className='text-lg font-light text-gray-700 hover:text-[#ffffff] transition-colors duration-300 hover:scale-105 transform' onClick={scrollToTop}>
                About
              </Link>
              <Link to="/contact" className='text-lg font-light text-gray-700 hover:text-[#ffffff] transition-colors duration-300 hover:scale-105 transform' onClick={scrollToTop}>
                Contact
              </Link>
            </nav>
          </div>

          {/* Contact Section */}
          <div className='flex flex-col lg:w-1/3 w-full items-center justify-start'>
            <div className='bg-white/70 backdrop-blur-sm rounded-3xl p-8 shadow-xl border border-white/20 hover:shadow-2xl transition-all duration-300 w-full max-w-sm'>
              <h3 className='text-2xl md:text-3xl font-light text-center text-gray-800 mb-8'>Get In Touch</h3>
              <div className='flex items-center justify-center gap-4 flex-wrap'>
                <a href="mailto:jasminpanag75@gmail.com" className='group p-4 bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl hover:from-purple-100 hover:to-pink-100 transition-all duration-300 hover:scale-110 hover:shadow-lg'>
                  <HiOutlineMailOpen size={28} className='text-black group-hover:text-black transition-colors duration-300' />
                </a>
                <div className='group p-4 bg-gradient-to-br from-blue-50 to-teal-50 rounded-2xl hover:from-blue-100 hover:to-teal-100 transition-all duration-300 hover:scale-110 hover:shadow-lg cursor-pointer'>
                  <GoLocation size={28} className='text-black group-hover:text-black transition-colors duration-300' />
                </div>
                <a href="tel:+15197746044" className='group p-4 bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl hover:from-green-100 hover:to-emerald-100 transition-all duration-300 hover:scale-110 hover:shadow-lg'>
                  <IoChatbubbleOutline size={28} className='text-black group-hover:text-black transition-colors duration-300' />
                </a>
                <a href="tel:+15197746044" className='group p-4 bg-gradient-to-br from-orange-50 to-yellow-50 rounded-2xl hover:from-orange-100 hover:to-yellow-100 transition-all duration-300 hover:scale-110 hover:shadow-lg'>
                  <CiPhone size={28} className='text-black group-hover:text-black transition-colors duration-300' />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright Section */}
        <div className='flex items-center justify-center pt-8'>
          <p className='text-sm text-gray-600 text-center'>
            © 2024 Yogabyjasmin. All Rights Reserved. | Crafted with ❤️ for mindful living
          </p>
        </div>
      </div>
    </div>
  );
}

export default Footer;